module.exports = __webpack_public_path__ + "img/feature_buy_th.a044c911.png";